"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var components_1 = require("@bodiless/components");

var FilterByGroupContext_1 = require("./FilterByGroupContext");

var asFilterableByGroup = function asFilterableByGroup(nodeKey) {
  if (nodeKey === void 0) {
    nodeKey = '_tags';
  }

  return lodash_1.flow(core_1.withSidecarNodes(components_1.asTaggableItem(nodeKey), components_1.withFilterByTags), FilterByGroupContext_1.withTagProps({
    placeholder: 'Add or Create',
    formTitle: 'Group Membership',
    formBodyText: 'Select from available groups:',
    seeAllText: 'View All Groups',
    noSuggestionsText: 'No matching groups found.'
  }));
};

exports.default = asFilterableByGroup;